import { SelectPicker } from "rsuite";

type Props = {
  onChange: (entries: string | number) => void;
};

const dropDownItem = [
  { label: 10, value: 10 },
  { label: 20, value: 20 },
  { label: 40, value: 40 },
];

export function PaginationEntriesInput({ onChange }: Props): JSX.Element {
  return (
    <div className="pagination-number-input">
      <SelectPicker
        placeholder="Show Entries"
        searchable={false}
        cleanable={false}
        data={dropDownItem}
        defaultValue={dropDownItem[0].value}
        onChange={(value) => onChange(value)}
        placement="topStart"
      />
    </div>
  );
}
